import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCodepenComponent } from './simple-icons-codepen.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCodepenComponent ],
    exports:      [ SimpleIconsCodepenComponent ],
    bootstrap:    []
})
export class SimpleIconsCodepenModule {}
